import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@app/shared/guards/auth.guard';
import {ClinicianDashboardRoutes} from '@shared/common/routing/clinician-dashboard-routes';
import {ClinicianDashboardIndexComponent} from '@clinician/clinician-dashboard-index.component';
import { AccountIndexComponent } from './account/account-index.component';
import { SecureDocumentUploadComponent } from '@app/views/public/secure-document-upload/secure-document-upload.component';

const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: 'cn'},
  {
    path: ClinicianDashboardRoutes.DASHBOARD_PREFIX,
    loadChildren: () => import('./clinician-dashboard/clinician-dashboard.module').then(m => m.ClinicianDashboardModule),
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: ClinicianDashboardIndexComponent,
  },
  {
    path: 'onboarding/:flowKey/:stepKey',
    canActivate: [AuthGuard],
    loadComponent: () => import('@app/views/onboarding/onboarding-view.component').then(m => m.OnboardingViewComponent),
  },
  {
    path: 'onboarding',
    canActivate: [AuthGuard],
    loadComponent: () => import('@app/views/onboarding/onboarding-view.component').then(m => m.OnboardingViewComponent),
  },
  {
    path: 'account',
    loadChildren: () => import ('./account/account.module').then(m => m.AccountModule),
    component: AccountIndexComponent
  },
  {
    path: 'consultation-invite',
    loadComponent: () => import('@app/views/appointments/consultation-invite/consultation-invite.component').then(m => m.ConsultationInviteComponent)
  },
  {
    path: 'secure-document-upload',
    component: SecureDocumentUploadComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false, initialNavigation: 'enabledNonBlocking'})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
